import Cookies from 'js-cookie'
import history from './history'

export const is_logged_in = () => {
    return !!Cookies.get('user_authed')
}

export const log_in = () => {
    Cookies.set('user_authed', true, {expires: 86400, sameSite: 'lax'})
    history.push('/');
}

export const log_out = () => {
    Cookies.remove('user_authed', {expires: 86400, sameSite: 'lax'})
    history.push('/login');
}
